<div *ngIf="showHeader" class="sidebar header-spacing"></div>
<nb-card *ngIf="general != null">
  <nb-card-header><h4>General Contact</h4></nb-card-header>
  <nb-card-body>
    <ngx-form-list-contact-entry-preview [value]="general"></ngx-form-list-contact-entry-preview>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-body>
    <ngx-form-module title="Enabled" [(value)]="item.active"></ngx-form-module>
    <ngx-form-text title="Name" [(value)]="item.name" [disabled]="$any(cantChangeName(item))"></ngx-form-text>
    <ngx-form-dropdown title="Type" [(value)]="item.type" displayField="value" keyField="key" [options]="BusinessType | enumKeys"></ngx-form-dropdown>
    <ngx-form-region title="Region" [(value)]="$any(item).region"></ngx-form-region>
    <ngx-form-contact title="Responsible" [(value)]="$any(item).manager"></ngx-form-contact>
    <ngx-form-text [multiline]="2" title="Remarks" [(value)]="item.remark"></ngx-form-text>
    <ngx-form-text [multiline]="2" title="General Information" [(value)]="item.generalInfo"></ngx-form-text>
    <ngx-form-check title="DN Box Table" [(value)]="item.dnBoxTable"></ngx-form-check>
    <ngx-form-text title="Position Number Format" [(value)]="item.positionNumberFormat" [disabled]="$any(cantChangeName(item))"></ngx-form-text>
    <div class="pseudo-link" [nbPopover]="posHelp">Position Number Format Help</div>
    <ng-template #posHelp>
      <div class="printf-help text-sm m-4">
        <h2 class="text-lg font-semibold mb-2">Position Number Format Options</h2>
        <table class="table-auto border-collapse w-full text-left border border-gray-400">
          <thead class="bg-gray-100">
            <tr>
              <th class="border border-gray-400 px-2 py-1">Format</th>
              <th class="border border-gray-400 px-2 py-1">Description</th>
              <th class="border border-gray-400 px-2 py-1">Example</th>
              <th class="border border-gray-400 px-2 py-1">Output</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-gray-400 px-2 py-1"><code>%d</code></td>
              <td class="border border-gray-400 px-2 py-1">Insert a decimal number</td>
              <td class="border border-gray-400 px-2 py-1"><code>P%d.</code></td>
              <td class="border border-gray-400 px-2 py-1">P1.</td>
            </tr>
            <tr>
              <td class="border border-gray-400 px-2 py-1"><code>%0Nd</code></td>
              <td class="border border-gray-400 px-2 py-1">Decimal number padded to N digits with zeros</td>
              <td class="border border-gray-400 px-2 py-1"><code>%05d</code></td>
              <td class="border border-gray-400 px-2 py-1">00001</td>
            </tr>
          </tbody>
        </table>

        <p class="mt-3 text-gray-700">
          <b>Example:</b>
          <br>
          <code><b>'L%02d0' for number 1 → {{ 'L%02d0' | printf:1 }}</b></code>
        </p>
      </div>
    </ng-template>
  </nb-card-body>
</nb-card>

<ngx-form-list-contact [(value)]="item.contacts"></ngx-form-list-contact>

<div *ngIf="showHeader" class="sidebar header-spacing"></div>
<div *ngIf="showHeader" class="sidebar header">
  <h1> {{item.name || 'Create new business'}}</h1>
</div>
<div *ngIf="showFooter" class="sidebar footer">
  <div class="row">
    <div class="mx-auto">
      <button class="btn btn-default btn-sm" (click)="cancel.emit(item)">Back</button>
      <button class="btn btn-primary btn-sm" (click)="save.emit(item)" [disabled]="isSaving">Save</button>
    </div>
  </div>
</div>